import { createTheme } from '@mui/material/styles';

const brand = {
  main: '#0f766e',
  dark: '#0b4f4a',
  light: '#14978d',
  contrastText: '#ffffff',
};

const accent = {
  main: '#d35400',
  dark: '#a74300',
  light: '#ef8c47',
  contrastText: '#ffffff',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: brand,
    secondary: accent,
    background: {
      default: '#f2f5f3',
      paper: '#ffffff',
    },
    text: {
      primary: '#1d2b28',
      secondary: '#62716c',
    },
    error: {
      main: '#c73b2a',
    },
    warning: {
      main: '#d68122',
    },
    success: {
      main: '#2f8a5b',
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: '"Manrope", "Segoe UI", "Tahoma", sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.015em',
    },
    h4: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.015em',
    },
    h5: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 650,
      letterSpacing: '-0.01em',
    },
    h6: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      fontWeight: 650,
      letterSpacing: '-0.01em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.01em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(15, 44, 38, 0.08)',
          boxShadow: '0 16px 34px rgba(13, 40, 34, 0.09)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 20,
          border: '1px solid rgba(15, 44, 38, 0.08)',
          boxShadow: '0 30px 70px rgba(17, 40, 33, 0.22)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: 14,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: '#0f766e',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 12,
          backgroundColor: 'rgba(16, 34, 29, 0.95)',
          fontSize: '0.78rem',
          lineHeight: 1.45,
          padding: '10px 12px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
    },
  },
});

export default theme;
